@if (formGroup) {
  @if (formGroup.get(formGroupOrControlName); as control) {
    <div [formGroup]="formGroup" class="metabi-control">
      <app-field-label [for]="formGroupOrControlName">
        {{ getLabel() }}
      </app-field-label>
      <div class="input-wrapper">
        <input
          [formControlName]="formGroupOrControlName"
          type="number"
          [placeholder]="placeholder || getLabel()"
          [min]="min"
          [max]="max"
          [attr.autocomplete]="'off'"
          [attr.data-lpignore]="'true'"
          [attr.data-1p-ignore]="'true'"
          (input)="onChange($event)"
          />
      </div>
      @if (control.errors && control.touched) {
        <app-field-error>
          {{ curateValidationHint(control) }}
        </app-field-error>
      }
    </div>
  }
}
